import { render, staticRenderFns } from "./noticebar.vue?vue&type=template&id=257e2140&"
import script from "./noticebar.vue?vue&type=script&lang=js&"
export * from "./noticebar.vue?vue&type=script&lang=js&"
import style0 from "./noticebar.vue?vue&type=style&index=0&id=257e2140&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports